export const PENDING_LYRICS_KEY = 'ba_lyrics_pending';

export function guestLyricsKey(guestSessionId) {
  return guestSessionId ? `ba_lyrics_guest_${guestSessionId}` : null;
}

export function lyricsStorageKey({ isGuest, guestSessionId }) {
  return isGuest ? guestLyricsKey(guestSessionId) : null;
}

export function guestSessionIdFromToken(token) {
  try {
    const encoded = token?.split('.')[1];
    if (!encoded) return null;
    const base64 = encoded.replace(/-/g, '+').replace(/_/g, '/');
    const padded = base64.padEnd(Math.ceil(base64.length / 4) * 4, '=');
    const payload = JSON.parse(atob(padded));
    const sessionId = payload.session_id || payload.sub;
    return typeof sessionId === 'string' ? sessionId : null;
  } catch (error) {
    return null;
  }
}

export function readGuestLyrics(storage, guestSessionId) {
  const key = guestLyricsKey(guestSessionId);
  if (!key) return null;
  try {
    const raw = storage.getItem(key);
    return raw ? JSON.parse(raw) : null;
  } catch (error) {
    return null;
  }
}

export function writeGuestLyrics(storage, guestSessionId, lyrics) {
  const key = guestLyricsKey(guestSessionId);
  if (key) storage.setItem(key, JSON.stringify(lyrics));
}

export function clearCurrentGuestLyrics(storage, guestSessionId) {
  const key = guestLyricsKey(guestSessionId);
  if (key) storage.removeItem(key);
}
